import React from "react";
import carFinishedImg from "../../../../assets/images/keyless-return/car-finished.svg";


export function FinishedRentalContent({t}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
        gap: "16px",
      }}
    >

      <img
        src={carFinishedImg}
        alt="A terminar aluguer"
        className="return-image"
      />


      <p
        style={{
          fontSize: "14px",
          color: "#333",
          margin: 0,
          lineHeight: "1.4",
        }}
      >
        <strong>{t("keylessReturnThankYou")}</strong>
        <br />
        {t("keylessReturnSafeTrip")}
      </p>

      <p
        style={{
          fontSize: "12px",
          color: "#666",
          margin: "8px 0 0 0",
          lineHeight: "1.4",
        }}
      >
        {t("keylessReturnStationReview")}
      </p>
    </div>
  );
}
